import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import clsx from 'clsx';

const MarketingCard = ({
  image,
  title,
  description,
  ctaText,
  ctaLink,
  size = 'small',
}) => {
  const classes = useMemo(() => {
    if (size === 'small') {
      return {
        container: '',
        content: 'p-8 pt-34',
      };
    }
    return {
      container: 'col-span-2 md:row-span-2 pb-[173%] md:pb-0',
      content: 'p-16 pt-64',
    };
  }, [size]);

  const CardComponent = ctaLink ? 'a' : 'div';

  return (
    <CardComponent
      className={`marketing-card relative block ${classes.container}`}
      href={ctaLink || undefined}
    >
      <img
        src={image}
        alt={title}
        loading="lazy"
        className="absolute inset-0 object-cover w-full h-full"
      />
      <div
        className={`absolute left-0 bottom-0
         to-black/0 text-white w-full ${classes.content}`}
      >
        <div className="display-4">{title}</div>
        {!!description.length && (
          <div className="body-2 max-w-[500px] pt-4 ml:pt-8">{description}</div>
        )}
        {!!ctaText && !!ctaLink && (
          <span
            className={clsx('cta-primary ml:pb-0 inline-block mt-16 pb-4', {
              'lc:mt-8': size !== 'small',
            })}
          >
            {ctaText}
          </span>
        )}
      </div>
    </CardComponent>
  );
};

export default MarketingCard;
